import { computed, ref, watch } from 'vue'
import { useNetwork } from './useNetwork'

export const useQueue = (options: { networkRequired?: boolean } = { networkRequired: false }) => {
  const pending = ref<(() => Promise<any>)[]>([])
  const active = ref<boolean>(false)
  // const complete = ref<(() => Promise<any>)[]>([])

  const getStatus = computed((): boolean => {
    if (options.networkRequired) {
      return useNetwork().getStatus.value
    }
    return true
  })
  const queue =
    <T extends any[], F extends (...inputs: any[]) => Promise<any>>(
      args: T,
      fn: F,
      resolve: any,
      reject: any
    ) =>
    async () =>
      await fn(...args)
        .then(() => {
          resolve()
        })
        .catch(() => {
          reject()
        })

  const addToQueue = <T extends any[], F extends (...inputs: any[]) => Promise<any>>(
    args: T,
    fn: F
  ): Promise<void> => {
    // console.log('add to queue')
    return new Promise((resolve, reject) => {
      pending.value.push(queue([...args], fn, resolve, reject))
    })
  }
  const queueSuccess = () => {
    // console.log('queue success')
    active.value = false
    // complete.value.push(pending.value[0])
    pending.value = pending.value.slice(1)
  }
  const queueError = () => {
    active.value = false
  }
  const startNext = async () => {
    if (active.value === false && getStatus.value === true && pending.value.length > 0) {
      // console.log('starting next')
      active.value = true
      await pending.value[0]().catch((error) => console.log(error))
    }
  }

  const cancelQueue = async () => {
    //remove todo items
    pending.value = []
    active.value = false
  }

  watch(
    pending,
    async () => {
      if (getStatus.value === true) await startNext().catch((error) => console.log(error))
    },
    { deep: true, flush: 'post' }
  )
  watch(getStatus, async () => {
    if (getStatus.value === true && pending.value.length > 0)
      await startNext().catch((error) => console.log(error))
  })

  return {
    addToQueue,
    queueSuccess,
    queueError,
    cancelQueue,
  }
}
